import { client } from '@atlassian/rovo-content-bridge-api/client-types';

export const JIRA_SMART_CREATE_MODAL_CLIENT_ID = client('jira-smart-create-modal');

export const JIRA_SMART_CREATE_TABLE_CLIENT_ID = client('jira-smart-create-table');
